import { Navigate, Route } from "react-router-dom";
import { QualityPage } from "@/v2/pages/quality/QualityPage";
import { EvaluationsPage } from "@/v2/pages/quality/evaluation/EvaluationsPage";
import { ValidationListPage } from "@/v2/pages/quality/validation/ValidationListPage";
import { ValidationPage } from "@/v2/pages/quality/validation/ValidationPage";
import ScorecardsListPage from "@/v2/pages/quality/sampling/ScorecardsListPage";
import ScorecardPage from "@/v2/pages/quality/sampling/ScorecardPage";
import CreateSamplePage from "@/v2/pages/quality/sampling/CreateSamplePage";
import EditSamplePage from "@/v2/pages/quality/sampling/EditSamplePage";
import { qualityUris } from "./qualityUris";

import { Evaluations } from "@/routes/quality";
import Validations from "@/v2/routes/validations/Validations";

export const qualityRoutes = (
  <>
    <Route path={qualityUris.root} element={<QualityPage />}>
      <Route path={qualityUris.evaluations} element={<EvaluationsPage />} />
      <Route path={qualityUris.validations} element={<ValidationListPage />} />
      <Route path={qualityUris.scorecards} element={<ScorecardsListPage />} />

      <Route path="*" element={<Navigate to={qualityUris.evaluations} />} />
      <Route
        index
        element={<Navigate to={qualityUris.evaluations} replace />}
      />
    </Route>

    <Route
      path={`${qualityUris.root}/${qualityUris.validation}`}
      element={<ValidationPage />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.scorecard}`}
      element={<ScorecardPage />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.createScorecard}`}
      element={<CreateSamplePage />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.editScorecard}`}
      element={<EditSamplePage />}
    />
  </>
);

export const oldQualityRoutes = (
  <>
    <Route
      path={`${qualityUris.root}/${qualityUris.evaluations}`}
      element={<Evaluations />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.validations}`}
      element={<Validations />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.scorecards}`}
      element={<ScorecardsListPage />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.scorecard}`}
      element={<ScorecardPage />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.createScorecard}`}
      element={<CreateSamplePage />}
    />
    <Route
      path={`${qualityUris.root}/${qualityUris.editScorecard}`}
      element={<EditSamplePage />}
    />
  </>
);
